export type PhotoShootImageData = {
  id: string;
  name: string;
  url: string;
};

export enum PhotoShootItemType {
  MENU_ITEM = 'MENU_ITEM',
  HEADER = 'HEADER',
  LIST = 'LIST',
}

export type PhotoShootItemData = {
  id: string;
  menuItemId: string | null;
  name: Localization[];
  imageIds: string[];
  description?: Localization[];
  itemType: PhotoShootItemType;
};

export enum PhotoShootStatus {
  CREATED = 'CREATED',
  UPLOADED = 'UPLOADED',
  APPROVED = 'APPROVED',
}

export type StatusHistory = {
  person: {
    email: string;
    id: string;
    name: string;
    type: string;
  };
  status: PhotoShootStatus;
  timestamp: string;
};

export type PhotoShootData = {
  venueId: string;
  venueName: string;
  expiresIn: string;
  createdAt: string;
  images: PhotoShootImageData[];
  items: PhotoShootItemData[];
  status: PhotoShootStatus;
  statusHistory: StatusHistory[];
};

export type PhotoShootLinkData = {
  expiresIn: string;
  url: string;
};

export type UploadImageUrlData = {
  fileId: string;
  fileName: string;
  url: string;
  cdnUrl: string;
};

export type UploadImagesData = {
  uploadUrls: UploadImageUrlData[];
};

export type DownloadImageUrl = {
  fileId: string;
  fileName: string;
  downloadUrl: string;
};

export type DownloadImagesData = {
  downloadUrls: DownloadImageUrl[];
};
